<template>
  <div class="CompanyProfile indexMain clear">
    <div class="title" ref="memberContent">
      <div class="t_cn">公司简介</div>
      <div class="t_en">COMPANY PROFILE</div>
    </div>
    <div class="cont clear">
      <div class="cont_left">
        <div class="btn btn-paly" @click="OnShowVideo"></div>
      </div>
      <div class="cont_right">
        <p class="infoTitle">
          <span class="i_cn">梧州黄埔化工药业有限公司</span>
          <span class="i_en">COMPANY PROFILE</span>
        </p>
        <i class="unLine"></i>
        <div class="infoCont clear">
          <p class="infoText">
            梧州黄埔化工药业有限公司（以下简称“梧州黄埔”）前身为“广州黄埔化工有限公司”，
            根据广州市“退二进三”的战略部署，于2010年10月在梧州注册成立。2011年梧州黄埔新工厂动工建设，2013年9月梧州黄埔年产3000吨合成樟脑、800吨冰片项目于梧州市松脂产业园区建成试生产。
          </p>
          <p class="infoText">
            梧州黄埔现为广州工业投资控股集团有限公司属下国有全资企业。梧州黄埔于2021年4月收购了广西梧州日成林产化工股份有限公司70%股权，日成林化属下还有梧州市日成太平林产化工有限公司、岑溪东林松香有限公司2个独资子公司。梧州黄埔公司位于梧州市万秀区梧松路1号，占地面积55亩、建筑面积22000平方米，有员工210余人；属下企业占地面积229亩、建筑面积约31000平方米，有员工280余人。
          </p>
          <p class="infoText">
            作为合成樟脑和冰片原料药的传统生产企业，梧州黄埔是世界上较早以化学合成工艺生产冰片和国内较早能按各国药典标准生产药用级樟脑的厂家。主要产品“白雪”牌冰片有70多年的生产历史，拳头产品“广达”牌合成樟脑更是享誉国内外，深受客户青睐，在1980年、1986年获广东省优质产品称号，1982年荣获国家化工部优质产品称号。除此还可生产莰烯、双戊烯、醋酸异龙脑酯、醋酸钠、α-蒎烯、β-蒎烯等不同品种、规格的产品。获得药品生产许可证、ISO质量管理体系认证、ISO环境管理体系认证、冰片（合成龙脑）注册证、樟脑（合成）备案登记等资质；拥有有效专利11项，其中发明专利2项，实用型专利7项，外观专利2项。
          </p>
          <p class="infoText">
            跨越七十余载春秋，历经涅槃重生。十年来，梧州黄埔以搬迁作为转型升级的契机，发扬优秀传统，优化生产工艺，不断拓宽成长之路，在产学研融合发展、客户合作和市场开拓、助力地方社会经济方面获得提升，收到了较好的经济效益和社会效益。近年来先后通过梧州市农业产业化重点龙头企业认定、广西自治区级林业产业重点龙头企业认定、广西自治区高新技术企业认定等，获得2017、2018年度梧州市出口先进企业、2019年度梧州市成长型企业等荣誉称号。
          </p>
          <p class="infoText">
            梧州黄埔将永远秉持“质量第一，守法经营，顾客至上”的方针，竭尽所能满足客户的各项需求，继续为做大做强做优国有企业而不懈奋斗；以继承公司创始人陈秋安先生振兴中华、实业报国的初心为使命，以打造“全球最好的药用级樟脑，最具品牌影响力的冰片”为目标，为万民健康保驾护航，为民族品牌砥砺前行。
          </p>
        </div>
        <div class="box-data clear">
          <div
            class="data_item"
            v-for="(item, index) in infoList"
            :key="'data_item' + index"
          >
            <div class="item_tit">
              <div class="data_icon">
                <img :src="item.iconSrc" :alt="item.infoTxt" />
              </div>
              <span class="data_txt">{{ item.infoTxt }}</span>
            </div>
            <div class="item_num">
              <animate-number
                class="i_data"
                ref="myNum"
                from="1"
                mode="manual"
                :to="item.infoNum"
              ></animate-number>
              <span class="i_danwei">{{ item.infoUnit }}</span>
            </div>
          </div>
        </div>
        <router-link to="/company">
          <div class="btn-more">
            <span>查看详情</span>
            <i class="jiantou_right"></i>
          </div>
        </router-link>
      </div>
    </div>
    <VideoModel
      ref="InfoVideoModel"
      :isShowVideo.sync="isShowVideo"
      :videoSrc="videoSrc"
    ></VideoModel>
  </div>
</template>

<script>
import VideoModel from '@/components/common/VideoModel.vue'
export default {
  data() {
    return {
      showTip: false,
      infoList: [
        {
          iconSrc: require('../../assets/images/index/info_icon1.png'),
          infoTxt: '历史底蕴',
          infoNum: 72,
          infoUnit: '年',
        },
        {
          iconSrc: require('../../assets/images/index/info_icon2.png'),
          infoTxt: '建筑面积',
          infoNum: 22000,
          infoUnit: '㎡',
        },
        {
          iconSrc: require('../../assets/images/index/info_icon3.png'),
          infoTxt: '荣誉资质',
          infoNum: 13,
          infoUnit: '项+',
        },
        {
          iconSrc: require('../../assets/images/index/info_icon4.png'),
          infoTxt: '年产樟脑',
          infoNum: 3000,
          infoUnit: '吨',
        },
      ],
      // 视频是否播放
      isShowVideo: false,
      // videoSrc: require('../../assets/video/infoVideo.mp4'),
      videoSrc:
        'https://hg1-news.oss-cn-hangzhou.aliyuncs.com/video/2025%E5%B9%B4%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91-%E6%A2%A7%E5%B7%9E%E9%BB%84%E5%9F%94%E5%8C%96%E5%B7%A5%E8%8D%AF%E4%B8%9A%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%EF%BC%88200M%EF%BC%89.mp4',
    }
  },
  mounted() {
    this.showTip = true
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll) // 监听（绑定）滚轮滚动事件
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop //滚动高度
      let boxHeight = 0
      boxHeight = this.$refs.memberContent.clientHeight //盒子高度
      if (boxHeight - scrollHeight <= 30) {
        this.showTip = true
      } else {
        this.showTip = false
      }
    },
    OnShowVideo() {
      this.$refs.InfoVideoModel.OnShowVideo()
    },
  },
  watch: {
    showTip(newval, oldval) {
      if (newval && this.$refs.myNum) {
        this.$refs.myNum.map((item) => {
          item.start()
        })
      }
    },
  },
  components: { VideoModel },
}
</script>

<style lang="scss" scoped>
.CompanyProfile {
  position: relative;
  padding: 1.04vw 0 0 0;
  z-index: 1000;
  .cont {
    width: 100%;
    position: relative;
    .cont_left {
      width: 45.31vw;
      height: 26.46vw;
      background: url('../../assets/images/index/companyInfoBg.png') no-repeat;
      background-size: contain;
      position: absolute;
      left: 0;
      top: 3.13vw;
      .btn-paly {
        cursor: pointer;
        width: 2.86vw;
        height: 2.86vw;
        background: url('../../assets/images/index/btn_paly.png') no-repeat;
        background-size: cover;
        position: absolute;
        top: 50%;
        left: 18.23vw;
        margin: -1.46vw 0 0 0;
      }
    }
    .cont_right {
      float: right;
      width: 35.42vw;
      min-height: 34.9vw;
      padding: 2.08vw;
      box-sizing: border-box;
      background-color: #303238;
      position: relative;
      .infoTitle {
        .i_cn {
          font-size: 1.25vw;
          line-height: 2.34vw;
          color: #83bb26;
        }
        .i_en {
          font-size: 1.56vw;
          line-height: 2.34vw;
          color: #666666;
          opacity: 0.2;
          padding: 0 0 0 0.52vw;
        }
      }
      .infoCont {
        padding: 1.04vw 0 0 0;
        max-height: 21.88vw;
        display: -webkit-box;
        text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 13;
        overflow: hidden;
        position: relative;
        &::after {
          float: right;
          content: '...';
          height: 20px;
          line-height: 20px;
          padding-right: 5px;
          text-align: right;
          width: 3em;
          margin-left: -3em;
          position: relative;
          left: 100%;
          top: -20px;
          padding-right: 5px;

          /* 为了展示效果更好 */
          background: -webkit-gradient(
            linear,
            left top,
            right top,
            from(rgba(255, 255, 255, 0)),
            to(white),
            color-stop(50%, white)
          );
          background: -moz-linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            white 50%,
            white
          );
          background: -o-linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            white 50%,
            white
          );
          background: -ms-linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            white 50%,
            white
          );
          background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0),
            white 50%,
            white
          );
        }
        .infoText {
          text-indent: 1.88vw;
          font-size: 0.83vw;
          color: #fff;
          line-height: 1.56vw;
          text-align: justify;
          word-break: normal;
        }
      }
      .box-data {
        width: 100%;
        position: relative;
        padding: 1.56vw 0 0 0;
        .data_item {
          float: left;
          width: 25%;
          position: relative;
          text-align: center;
          .item_tit {
            height: 1.56vw;
            margin: 0 auto;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .data_icon {
              display: block;
              width: 1.56vw;
              height: 1.56vw;
              position: relative;
              img {
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
            .data_txt {
              display: block;
              font-size: 0.83vw;
              line-height: 1.56vw;
              color: #ffffff;
            }
          }
          .item_num {
            width: 100%;
            text-align: center;
            padding: 0.52vw 0 0 0;
            .i_data {
              font-size: 1.56vw;
              font-weight: bold;
              color: #83bb26;
            }
            .i_danwei {
              padding: 0 0 0 0.31vw;
              font-size: 0.83vw;
              color: #83bb26;
            }
          }
        }
      }
      .btn-more {
        margin: 2.08vw 0 0 0;
        float: right;
        position: relative;
        cursor: pointer;
        &:hover {
          span {
            color: #ffffff;
          }
          .jiantou_right {
            background: url('../../assets/images/index/jisntou_right_on.png')
              no-repeat;
            background-size: 100%;
          }
        }

        span {
          font-size: 0.94vw;
          letter-spacing: 0.05vw;
          color: #89c61d;
          padding: 0 0.31vw 0 0;
        }
        .jiantou_right {
          display: inline-block;
          width: 1.98vw;
          height: 0.52vw;
          background: url('../../assets/images/index/jisntou_right.png')
            no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
$LiWidth: 3.85vw;
$unLineBackgroundColor: #83bb26;
.unLine {
  display: flex;
  width: $LiWidth;
  height: 0.21vw;
  box-sizing: border-box;
  position: relative;
  &::before {
    content: '';
    display: block;
    width: 0.42vw;
    height: 0.21vw;
    border-radius: 0.26vw;
    background: $unLineBackgroundColor;
  }
  &::after {
    content: '';
    flex: 1;
    height: 0.21vw;
    border-radius: 0.26vw;
    background: $unLineBackgroundColor;
    margin-left: 0.21vw;
  }
}
@media (min-width: 1920px) {
  .CompanyProfile {
    position: relative;
    padding: 20px 0 0 0;
    .cont {
      width: 100%;
      position: relative;
      .cont_left {
        width: 870px;
        height: 508px;
        background: url('../../assets/images/index/companyInfoBg.png') no-repeat;
        background-size: contain;
        position: absolute;
        left: 0;
        top: 60px;
        .btn-paly {
          cursor: pointer;
          width: 55px;
          height: 55px;
          background: url('../../assets/images/index/btn_paly.png') no-repeat;
          background-size: cover;
          position: absolute;
          top: 50%;
          left: 350px;
          margin: -28px 0 0 0;
        }
      }
      .cont_right {
        float: right;
        width: 680px;
        min-height: 670px;
        padding: 40px;
        box-sizing: border-box;
        background-color: #303238;
        position: relative;
        .infoTitle {
          .i_cn {
            font-size: 24px;
            line-height: 45px;
            color: #83bb26;
          }
          .i_en {
            font-size: 30px;
            line-height: 45px;
            color: #666666;
            opacity: 0.2;
            padding: 0 0 0 10px;
          }
        }
        .infoCont {
          max-height: 420px;
          padding: 20px 0 0 0;
          display: -webkit-box;
          text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 13;
          overflow: hidden;
          .infoText {
            text-indent: 36px;
            font-size: 16px;
            color: #fff;
            line-height: 30px;
            text-align: justify;
            word-break: normal;
          }
        }
        .box-data {
          padding: 30px 0 0 0;
          width: 100%;
          position: relative;
          .data_item {
            float: left;
            width: 25%;
            position: relative;
            text-align: center;
            .item_tit {
              height: 30px;
              margin: 0 auto;
              text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              .data_icon {
                display: block;
                width: 30px;
                height: 30px;
                position: relative;
                img {
                  display: inline-block;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .data_txt {
                display: block;
                font-size: 16px;
                line-height: 30px;
                color: #ffffff;
              }
            }
            .item_num {
              width: 100%;
              text-align: center;
              padding: 10px 0 0 0;
              .i_data {
                font-size: 30px;
                font-weight: bold;
                color: #83bb26;
              }
              .i_danwei {
                padding: 0 0 0 6px;
                font-size: 16px;
                color: #83bb26;
              }
            }
          }
        }
        .btn-more {
          margin: 40px 0 0 0;
          float: right;
          position: relative;
          cursor: pointer;
          &:hover {
            span {
              color: #ffffff;
            }
            .jiantou_right {
              background: url('../../assets/images/index/jisntou_right_on.png')
                no-repeat;
              background-size: 100%;
            }
          }

          span {
            font-size: 18px;
            letter-spacing: 1px;
            color: #89c61d;
            padding: 0 6px 0 0;
          }
          .jiantou_right {
            display: inline-block;
            width: 38px;
            height: 10px;
            background: url('../../assets/images/index/jisntou_right.png')
              no-repeat;
            background-size: 100%;
          }
        }
      }
    }
  }
  $LiWidth: 74px;
  $unLineBackgroundColor: #83bb26;
  .unLine {
    display: flex;
    width: $LiWidth;
    height: 4px;
    box-sizing: border-box;
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 8px;
      height: 4px;
      border-radius: 5px;
      background: $unLineBackgroundColor;
    }
    &::after {
      content: '';
      flex: 1;
      height: 4px;
      border-radius: 5px;
      background: $unLineBackgroundColor;
      margin-left: 4px;
    }
  }
}
</style>
